// extracted by mini-css-extract-plugin
module.exports = {"message_detail":"NewsDetail_message_detail_2gL2s"};